var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isNativeLink)?_c('a',{attrs:{"href":_vm.to,"target":_vm.linkTarget,"download":_vm.download}},[_vm._t("default")],2):_c('NuxtLink',{attrs:{"to":_vm.localePath(_vm.to),"target":_vm.linkTarget}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }